module.exports = __webpack_public_path__ + "static/media/alex-blajan-223771-unsplash.5a7360fb.jpg";